module.exports = __webpack_public_path__ + "media/src/img/sign-3ac072084341936b81f5ba2dcdf60de2.png";